export class ApplicantSelected{
    hmy:number;
    pCode:string;
    firstName:string;
    middleInitial:string;
    lastName:string;
    mailingAddress:string;
    apt:string;
    city:string;
    otherCity:string;
    state:string;
    zipCode:string;
    gender:string;
    homeTel:string;
    cellTel:string;
    email:string;
    tenantStatus:string; 
    dateSelected:Date; 
    dueDate:Date; 
    preferences:string;
    otherTCodes:string;  
}
